import React from "react";
import { useLocation } from "react-router-dom";

const CommonWebView = () => {
  const { state } = useLocation();
  const { title, url } = state;

  return (
    <iframe src={url} title={title} className="app-webview" />
  );
};

export default CommonWebView;
